import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { formatPhoneNumber } from 'src/utils/phone';
import createHoursOfOperationMap from 'src/utils/hoursOfOperation';

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(2),

    '& .MuiTableCell-root': {
      border: 0,
    },
    '& .MuiTableRow-root': {
      borderBottom: '1px solid rgba(224, 224, 224, 1)',
    },
  },
  fontWeightMedium: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  cardHeader: {
    color: theme.palette.secondary.main,
  },
  hoursOfOperation: {
    display: 'flex',
  },
}));

function ProviderInfo({
  providerName,
  providerPhone,
  providerEmail,
  providerHoursOfOperation,
  providerAddress,
  providerCity,
  providerState,
  providerCategory,
  digitalProviderNetwork,
  providerId,
}) {
  const classes = useStyles();

  if (!providerId) {
    return (
      <Card className={classes.card}>
        <CardHeader
          className={classes.cardHeader}
          title="Provider not assigned. Provider info not available"
        />
      </Card>
    );
  }

  return (
    <Card className={classes.card}>
      <CardHeader
        className={classes.cardHeader}
        title="Provider Info"
      />
      <Divider />
      <Table>
        <TableBody>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Name</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary">
                {providerName}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Category</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary">
                {providerCategory}
              </Typography>
            </TableCell>
          </TableRow>
          {digitalProviderNetwork ? (
            <TableRow>
              <TableCell className={classes.fontWeightMedium}>Provider Network</TableCell>
              <TableCell align="right">
                <Typography variant="body2" color="textSecondary">
                  {digitalProviderNetwork}
                </Typography>
              </TableCell>
            </TableRow>
          ) : null}
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Phone</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary">
                {formatPhoneNumber(providerPhone)}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Email</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary">
                {providerEmail}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>
              Hours Of Operation
            </TableCell>
            <TableCell className={classes.hoursOfOperation} align="right">
              <Box width="fit-content">
                {createHoursOfOperationMap(providerHoursOfOperation)
                  .map(({ start, end, hours }, i) => (
                    <React.Fragment key={i}>
                      <Typography variant="body2" color="textPrimary">
                        {start === end ? start : `${start} - ${end}`}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {hours}
                      </Typography>
                    </React.Fragment>
                  ))}
              </Box>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Address</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary">
                {providerAddress}
                <br />
                {providerCity}{' '}{providerState}
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Card>
  );
}

ProviderInfo.propTypes = {
  providerName: PropTypes.string,
  providerPhone: PropTypes.string,
  providerEmail: PropTypes.string,
  providerHoursOfOperation: PropTypes.string,
  providerAddress: PropTypes.string,
  providerCity: PropTypes.string,
  providerState: PropTypes.string,
  providerCategory: PropTypes.string,
  digitalProviderNetwork: PropTypes.string,
  providerId: PropTypes.number,
};

export default ProviderInfo;
